module.exports = __webpack_public_path__ + "img/home.68c238d0.svg";